import classes from './HeadingDep.module.css'; 

const HeadingDep = (props) => {
    return (
        <h3 className={classes.heading}>{props.content}</h3>
    )
}; 

export default HeadingDep; 